import { useI18n } from "@/i18n/I18nProvider";

const IUBENDA_COOKIE_URLS = {
    it: "https://www.iubenda.com/privacy-policy/93284770/cookie-policy",
    en: "https://www.iubenda.com/privacy-policy/93369101/cookie-policy",
    "en-gb": "https://www.iubenda.com/privacy-policy/59291688/cookie-policy",
    es: "https://www.iubenda.com/privacy-policy/87768663/cookie-policy",
    fr: "https://www.iubenda.com/privacy-policy/78494513/cookie-policy",
    pt: "https://www.iubenda.com/privacy-policy/56099177/cookie-policy",
};

function FooterBrand({ t }) {
    return (
        <div>
            <div
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 12,
                }}
            >
                <img
                    src="/assets/itly/logo-turista.png"
                    alt="ITLY"
                    style={{
                        width: 44,
                        height: 44,
                        borderRadius: 12,
                        objectFit: "contain",
                        objectPosition: "center",
                        display: "block",
                        background: "#8BAFC7",
                    }}
                />
                <span
                    className="itly-wordmark"
                    style={{ color: "#F7F4EE" }}
                >
                    ITLY
                </span>
            </div>
            <p
                style={{
                    marginTop: 20,
                    marginBottom: 0,
                    fontFamily: "Inter, sans-serif",
                    fontSize: 14.5,
                    lineHeight: 1.6,
                    color: "rgba(231, 241, 239, 0.72)",
                    maxWidth: 400,
                }}
            >
                {t("footer.tagline")}
            </p>
            <p
                style={{
                    marginTop: 22,
                    marginBottom: 0,
                    fontFamily: "Inter, sans-serif",
                    fontSize: 11.5,
                    fontWeight: 700,
                    letterSpacing: "0.24em",
                    textTransform: "uppercase",
                    color: "rgba(231, 241, 239, 0.55)",
                }}
            >
                Host & Guest Portal — FZCO
            </p>
        </div>
    );
}

function FooterContact({ t }) {
    return (
        <div>
            <p style={footerLabel}>{t("footer.contact")}</p>
            <ul style={footerList}>
                <li>
                    <a
                        href="mailto:info.itly9@gmail.com"
                        style={{
                            color: "#F7F4EE",
                            textDecoration: "none",
                            borderBottom: "1px solid rgba(247,244,238,0.25)",
                        }}
                    >
                        info.itly9@gmail.com
                    </a>
                </li>
                <li style={{ color: "rgba(231, 241, 239, 0.72)" }}>
                    TRN 105475534100001
                </li>
            </ul>
        </div>
    );
}

function FooterPortal({ t, cookieUrl }) {
    return (
        <div>
            <p style={footerLabel}>{t("footer.portal")}</p>
            <ul style={footerList}>
                <li>
                    <a href="/" style={footerLink}>
                        ITLY
                    </a>
                </li>
                <li>
                    <a href="/partner" style={footerLink}>
                        ITLY HUB
                    </a>
                </li>
                <li>
                    <a href="/privacy" style={footerLink}>
                        {t("footer.privacy")}
                    </a>
                </li>
                <li>
                    <a
                        href={cookieUrl}
                        className="iubenda-white iubenda-noiframe iubenda-embed"
                        title="Cookie Policy"
                        style={footerLink}
                    >
                        {t("priv.card2.title")}
                    </a>
                </li>
            </ul>
        </div>
    );
}

function FooterBottom({ t }) {
    return (
        <div
            style={{
                maxWidth: 1200,
                margin: "48px auto 0",
                paddingTop: 24,
                borderTop: "1px solid rgba(231, 241, 239, 0.14)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 16,
                flexWrap: "wrap",
                fontFamily: "Inter, sans-serif",
                fontSize: 13,
                color: "rgba(231, 241, 239, 0.55)",
            }}
        >
            <span>© {new Date().getFullYear()} ITLY. {t("footer.rights")}</span>
            <span>{t("footer.madeWith")}</span>
        </div>
    );
}

export default function Footer() {
    const { t, lang } = useI18n();
    const cookieUrl = IUBENDA_COOKIE_URLS[lang] || IUBENDA_COOKIE_URLS.it;
    return (
        <footer
            data-testid="itly-footer"
            style={{
                background: "var(--itly-teal-900)",
                color: "#E7F1EF",
                padding: "56px 32px 32px",
            }}
        >
            <div
                style={{
                    maxWidth: 1200,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1fr)",
                    gap: 40,
                }}
                className="itly-footer-grid"
            >
                <FooterBrand t={t} />
                <FooterContact t={t} />
                <FooterPortal t={t} cookieUrl={cookieUrl} />
            </div>

            <FooterBottom t={t} />
        </footer>
    );
}

const footerLabel = {
    margin: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: "rgba(231, 241, 239, 0.55)",
};
const footerList = {
    marginTop: 18,
    padding: 0,
    listStyle: "none",
    fontFamily: "Inter, sans-serif",
    fontSize: 14.5,
    lineHeight: 1.9,
    color: "#F7F4EE",
};
const footerLink = {
    color: "#F7F4EE",
    textDecoration: "none",
    opacity: 0.85,
};
